import { types } from "./payment.type";

export const createOrder = (type, insuranceDetail, customerInfo, vehicleInfo, recipient) => {
  return {
    type: types.CREATING_ORDER,
    payload: {
      type,
      insuranceDetail,
      customerInfo,
      vehicleInfo,
      recipient,
    },
  };
};

export const createOrderCallback = (type, insuranceDetail, customerInfo, vehicleInfo, recipient, callback) => {
  return {
    type: types.CREATING_ORDER_CALLBACK,
    payload: {
      type,
      insuranceDetail,
      customerInfo,
      vehicleInfo,
      recipient,
      callback
    },
  };
};

export const createOrderHome = (type, insuranceDetail, customerInfo, homeInfo, recipient) => {
  return {
    type: types.CREATING_ORDER,
    payload: {
      type,
      insuranceDetail,
      customerInfo,
      homeInfo,
      recipient,
    },
  };
};

export const payOrder = (contractId, productType) => {
  return {
    type: types.CREATING_PAY_ORDER,
    payload: {
      contractId,
      productType
    }
  };
}

export const createPolicyDraft = (type, insuranceDetail, customerInfo, vehicleInfo,) => {
  return {
    type: types.CREATING_POLICY_DRAFT,
    payload: {
      type,
      insuranceDetail,
      customerInfo,
      vehicleInfo,
    }
  }
}

export const clearCheckPayment = () => {
  return {
    type: types.CLEAR_CHECK_PAYMENT,
  };
}

export const clearPaymentInfo = () => {
  return {
    type: types.CLEAR_PAYMENT_INFO,
  };
}

export const clearErrMess = () => {
  return {
    type: types.CLEAR_MESS_ERROR,
  };
}